import { render, staticRenderFns } from "./RestorePasswordView.vue?vue&type=template&id=70416c82&"
import script from "./RestorePasswordView.vue?vue&type=script&lang=js&"
export * from "./RestorePasswordView.vue?vue&type=script&lang=js&"
import style0 from "./RestorePasswordView.vue?vue&type=style&index=0&id=70416c82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports